import { Pantry } from './Pantry';

// Display mode for UI - either exploring map bounds or searching globally
export type DisplayMode = 'explore' | 'search';

// Filters that can be applied to both search and explore modes
export interface PantryFilters {
  verified?: boolean;
  pantryType?: string[];
  serviceType?: string[];
  openNow?: boolean;
}

// User's search intent with query text, filters, and context
export interface SearchQuery {
  text: string;
  filters?: PantryFilters;
  userLocation?: {
    latitude: number;
    longitude: number;
  };
  limit?: number;
  offset?: number;
  executedAt?: string;
}

// Container for search results from Algolia
export interface SearchResultSet {
  results: Pantry[];
  total: number;
  hasMore: boolean;
  query: string;
  executionTime?: number;
  source: 'algolia' | 'cache';
  fetchedAt: string;
}

// Redux state structure for pantry search and explore
export interface PantryState {
  // Search mode (global Algolia results)
  searchResults: Pantry[];
  loadingSearchResults: boolean;
  searchResultsError: string | null;
  searchQuery: string;
  searchTotalResults: number;
  searchHasMore: boolean;
  searchExecutedAt: string | null;

  // Shared state
  displayMode: DisplayMode;
  selectedPantry: Pantry | null;
  filters: PantryFilters;
  userLocation: {
    latitude: number;
    longitude: number;
  } | null;
}
